export function isRegistrationDemoEnabled() {
  return (
    process.env['NODE_ENV'] === 'development' &&
    process.env['NX_ADMIN_REGISTRATION_DEMO'] === 'true'
  );
}
